import StoresManagerVue from '@/views/sm/stores-manager/stores-manager.vue';

const basePath = '/sm/stores-manager';
const role = 'sm'; // 角色身份

export const SM_STORES_MANAGER_INDEX = 'sm-stores-manager-index';
export const SM_STORES_MANAGER_EDIT_SA = 'sm-sotres-manager-edit-sa';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: StoresManagerVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SM_STORES_MANAGER_INDEX,
      component: () => import(
        /* webpackChunkName: "stores-manager" */
        `@/views/${role}/stores-manager/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/editSa/:id`,
      name: SM_STORES_MANAGER_EDIT_SA,
      props: true,
      component: () => import(
        /* webpackChunkName: "stores-manager-edit-sa" */
        `@/views/${role}/stores-manager/editSa.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
